const GetEDoctorStatusName = (id) => {
    switch (id) {
        case 0: { return "Offline" }
        case 1: { return "In The Cabin" }
        case 4: { return "On Rest" }

    }
}

const GetEDoctorStatus = {
    EDoctorStatus: [
        { Id: 0, Name: "Offline" },
        { Id: 1, Name: "In The Cabined" },
        { Id: 4, Name: "On Rest" },

    ]
}

const EDoctorStatusBg = (id) => {
    switch (id) {
        case 0: return "bg-red-400"
        case 1: return "bg-green-400"
        case 4: return "bg-orange-400"
    }
}

export { GetEDoctorStatusName, GetEDoctorStatus, EDoctorStatusBg }